/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./App.css";
import { ImageSlider } from "./components/ImageSlider";

function App(props) {
  const { img } = props;
  const [appSettings, setAppSettings] = useState();
  const [currentImage, setCurrentImage] = useState({});
  const getSettingsData = async () => {
    const settings = await fetch("./settings.json");
    const settingsData = await settings.json();
    setCurrentImage(
      img && settingsData.images[img]
        ? settingsData.images[img]
        : settingsData.images[Object.keys(settingsData.images)[0]]
    );
    setAppSettings(settingsData);
  };

  useEffect(() => {
    getSettingsData();
  }, []);

  return (
    <div className="App">
      {appSettings && (
        <ImageSlider
          text={true}
          {...{
            width: currentImage.photoSize.width
              ? currentImage.photoSize.width
              : "100%",
            height: currentImage.photoSize.height
              ? currentImage.photoSize.height
              : "100%",
            image: currentImage.files,
            textColor: currentImage.textColor || "black",
          }}
        />
      )}
    </div>
  );
}

export default App;
